import React from 'react';
import AdminMasterLayout from '../../../layouts/gcadmin/adminMasterLayout/AdminMasterLayout';
import AdminDisputesPage from '../../../subsreens/gcadmin/disputepage/AdminDisputesPage';



const AdminDisputes = () => {
    return(
        <AdminMasterLayout>
            <AdminDisputesPage></AdminDisputesPage>
        </AdminMasterLayout>
    )
}

export default AdminDisputes;